// Helpers for themes where optional chaining / nullish 合并不被所有浏览器支持
function themeFlag(key){
  var t = window.THEME || {};
  return t[key];
}

// Page fade transitions for internal navigations
(function(){
  if(!themeFlag('pageFx')) return;
  document.addEventListener('click', (e)=>{
    const a = e.target.closest('a[href]');
    if(!a) return;
    const href = a.getAttribute('href');
    if(!href) return;
    // ignore new tabs / downloads / modifiers / anchors
    if(a.target === '_blank' || a.hasAttribute('download')) return;
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if(href.startsWith('#')) return;
    // ignore external
    try{
      const url = new URL(a.href, window.location.href);
      if(url.origin !== window.location.origin) return;
    }catch(_){ return; }
    // ignore Shopify cart ajax endpoints
    if(href.includes('/cart/add') || href.includes('/cart/change') || href.includes('/cart/update')) return;

    document.body.classList.add('is-leaving');
    setTimeout(()=>{ window.location.href = a.href; }, 120);
    e.preventDefault();
  });
})();

  // Hover FX toggle
  if(window.THEME && window.THEME.hoverFx === false){
    document.body.classList.add('no-hoverfx');
  }

  const $ = (sel, root=document)=>root.querySelector(sel);
  const $$ = (sel, root=document)=>Array.from(root.querySelectorAll(sel));


// Toast helper
function toast(type, title, message){
  if(!themeFlag('toasts')) return;
  const host = document.querySelector('[data-toast-host]');
  const stack = document.querySelector('[data-toast-stack]');
  if(!host || !stack) return;
  host.hidden = false;

  const el = document.createElement('div');
  el.className = 'toast toast-' + type;
  const ic = type === 'success' ? '✓' : (type === 'error' ? '!' : 'i');
  el.innerHTML = `
    <div class="toast-ic" aria-hidden="true">${ic}</div>
    <div class="toast-body">
      <p class="toast-title">${title || ''}</p>
      <p class="toast-msg">${message || ''}</p>
    </div>
    <button class="toast-close" type="button" aria-label="Close">✕</button>
  `;
  stack.prepend(el);
  requestAnimationFrame(()=>el.classList.add('is-in'));

  const close = ()=>{
    el.classList.remove('is-in');
    setTimeout(()=>{
      el.remove();
      if(stack.children.length === 0) host.hidden = true;
    }, 220);
  };
  var closeBtn = el.querySelector('.toast-close');
  if(closeBtn) closeBtn.addEventListener('click', close);
 
  const dur = Number(themeFlag('toastDur') != null ? themeFlag('toastDur') : 2500);
  setTimeout(close, dur);
}

function setBtnState(btn, state){
  if(!btn || !themeFlag('btnLoading')) return;
  btn.classList.toggle('is-loading', state === 'loading');
  btn.classList.toggle('is-success', state === 'success');
}

  // Language switcher popover
  $$('[data-lang]').forEach(el=>{
    const btn = $('.lang-btn', el);
    if(!btn) return;
    const close = (e)=>{
      if(!el.contains(e.target)){ el.classList.remove('is-open'); btn.setAttribute('aria-expanded','false'); document.removeEventListener('click', close); }
    };
    btn.addEventListener('click', (e)=>{
      e.preventDefault();
      const open = !el.classList.contains('is-open');
      el.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if(open) setTimeout(()=>document.addEventListener('click', close), 0);
    });
  });


// Reveal on scroll (with optional stagger)
if(themeFlag('anim')){
  const stagger = Number(themeFlag('animStagger') != null ? themeFlag('animStagger') : 0);
  // assign per-element delay using DOM order
  const revealEls = $$('.reveal');
  revealEls.forEach((el, i)=>{
    if(stagger > 0) el.style.transitionDelay = (i * stagger) + 'ms';
  });

  const io = new IntersectionObserver((entries)=>{
    entries.forEach(en=>{
      if(en.isIntersecting){
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      }
    });
  }, {threshold: 0.12});
  revealEls.forEach(el=>io.observe(el));
}

  // Cart drawer (basic open/close)
  const drawer = $('[data-cart-drawer]');
  const openBtns = $$('[data-cart-toggle]');
  const closeBtns = $$('[data-cart-close]');
  const openDrawer = ()=>{
    if(!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(()=>drawer.classList.add('is-open'));
    document.documentElement.style.overflow = 'hidden';
  };
  const closeDrawer = ()=>{
    if(!drawer) return;
    drawer.classList.remove('is-open');
    setTimeout(()=>{ drawer.hidden = true; }, 220);
    document.documentElement.style.overflow = '';
  };
  openBtns.forEach(b=>b.addEventListener('click', (e)=>{
    if(themeFlag('cartDrawer')){
      e.preventDefault();
      openDrawer();
    }
    // else: allow default link behavior to /cart
  }));
  closeBtns.forEach(b=>b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (e)=>{ if(e.key === 'Escape') closeDrawer(); });

  // Quick add (minimal: add variant to cart then open drawer)
  async function quickAdd(variantId, triggerBtn){
    try{
      setBtnState(triggerBtn, 'loading');
      const res = await fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({id: Number(variantId), quantity: 1})
      });
      if(!res.ok) throw new Error('Add to cart failed');
      // refresh cart badge (best effort)
      const cartRes = await fetch('/cart.js');
      if(cartRes.ok){
        const cart = await cartRes.json();
        const badge = $('[data-cart-count]');
        if(badge) badge.textContent = cart.item_count;
      }
      lastAddedVariantId = Number(variantId);
      setBtnState(triggerBtn, 'success');
      toast('success', 'Added to cart', 'Item was added successfully.');
      const hold = Number(themeFlag('successHold') != null ? themeFlag('successHold') : 900);
      setTimeout(()=>{ setBtnState(triggerBtn, null); }, hold);
      if(themeFlag('cartDrawer')) openDrawer();
    }catch(err){
      console.warn(err);
      toast('error', 'Couldn\'t add item', 'Please try again.');
      shake(triggerBtn);
      setBtnState(triggerBtn, null);
      window.location.href = '/cart';
    }
  }

  document.addEventListener('click', (e)=>{
    const btn = e.target.closest('[data-quick-add]');
    if(!btn) return;
    e.preventDefault();
    flyToCart(btn);
    const vid = btn.getAttribute('data-variant-id');
    if(vid) quickAdd(vid, btn);
  });


// 缩略图悬停切换主图功能（独立执行，不依赖其他代码）
(function(){
  let isSetup = false;
  
  function setupThumbHover(){
    if(isSetup) return;
    
    const heroImg = document.querySelector('.pdp-hero-img');
    if(!heroImg) return;
    
    const thumbsContainer = document.querySelector('.pdp-thumbs');
    if(!thumbsContainer) return;
    
    // 在容器上使用事件委托
    function handleMouseOver(e){
      const thumb = e.target.closest('[data-pdp-thumb]');
      if(!thumb) return;
      
      const src = thumb.getAttribute('data-src');
      if(!src) return;
      
      // 确保使用完整的 URL
      const fullSrc = src.startsWith('//') ? 'https:' + src : src;
      
      // 如果图片 URL 不同，强制切换
      if(heroImg.src !== fullSrc && heroImg.getAttribute('src') !== fullSrc){
        // 先移除 src，强制浏览器重新加载
        heroImg.removeAttribute('src');
        heroImg.removeAttribute('srcset');
        
        // 使用 requestAnimationFrame 确保 DOM 更新
        requestAnimationFrame(function(){
          heroImg.src = fullSrc;
          heroImg.setAttribute('src', fullSrc);
        });
      }
    }
    
    thumbsContainer.addEventListener('mouseover', handleMouseOver, false);
    isSetup = true;
  }
  
  // 立即执行
  setupThumbHover();
  
  // 页面加载完成后执行
  if(document.readyState === 'complete'){
    setupThumbHover();
  }else{
    window.addEventListener('load', setupThumbHover);
    document.addEventListener('DOMContentLoaded', setupThumbHover);
  }
  
  // 延迟执行，确保所有脚本都加载完成
  setTimeout(setupThumbHover, 300);
  setTimeout(setupThumbHover, 1000);
  setTimeout(setupThumbHover, 2000);
})();

// PDP Pro behavior (variants, thumbs, sticky ATC)
(function(){
// Page fade transitions for internal navigations
(function(){
  if(!themeFlag('pageFx')) return;
  document.addEventListener('click', (e)=>{
    const a = e.target.closest('a[href]');
    if(!a) return;
    const href = a.getAttribute('href');
    if(!href) return;
    // ignore new tabs / downloads / modifiers / anchors
    if(a.target === '_blank' || a.hasAttribute('download')) return;
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if(href.startsWith('#')) return;
    // ignore external
    try{
      const url = new URL(a.href, window.location.href);
      if(url.origin !== window.location.origin) return;
    }catch(_){ return; }
    // ignore Shopify cart ajax endpoints
    if(href.includes('/cart/add') || href.includes('/cart/change') || href.includes('/cart/update')) return;

    document.body.classList.add('is-leaving');
    setTimeout(()=>{ window.location.href = a.href; }, 120);
    e.preventDefault();
  });
})();

  // Hover FX toggle
  if(window.THEME && window.THEME.hoverFx === false){
    document.body.classList.add('no-hoverfx');
  }
  
  const jsonEl = document.querySelector('[id^="ProductJson-"]');
  if(!jsonEl) return;
  let product;
  try{ product = JSON.parse(jsonEl.textContent); }catch(e){ return; }

  const form = document.getElementById('product-form');
  if(!form) return;

  const variantInput = form.querySelector('[data-variant-id]');
  const priceEl = document.querySelector('[data-price]');
  const compareEl = document.querySelector('[data-compare]');
  const sticky = document.querySelector('[data-sticky-atc]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyBtn = document.querySelector('[data-sticky-submit]');
  const atcBtn = form.querySelector('[data-atc]');
  const heroImg = document.querySelector('.pdp-hero-img');
  const thumbButtons = document.querySelectorAll('[data-pdp-thumb]');

  // 点击缩略图切换主图（保留原有功能）
  if(heroImg && thumbButtons.length > 0){
    document.addEventListener('click', (e)=>{
      const b = e.target.closest('[data-pdp-thumb]');
      if(!b || !heroImg) return;
      const src = b.getAttribute('data-src');
      if(src){
        heroImg.removeAttribute('srcset');
        heroImg.src = src;
        // 更新缩略图按钮状态
        thumbButtons.forEach(btn => {
          btn.classList.toggle('is-active', btn === b);
        });
      }
    });
  }

  // options to selected values
  const optionRows = form.querySelectorAll('[data-option-index]');
  const selected = new Array(product.options.length).fill(null);

  // init defaults from first available variant
  const defaultVariant = product.variants.find(v=>v.available) || product.variants[0];
  if(defaultVariant){
    defaultVariant.options.forEach((v,i)=>selected[i]=v);
  }

  function findVariant(){
    return product.variants.find(v => v.options.every((opt, i)=>opt === selected[i])) || null;
  }

  function updateUI(variant){
    if(!variant) return;
    if(variantInput) variantInput.value = variant.id;
    if(priceEl) priceEl.textContent = formatMoney(variant.price);
    if(stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    if(compareEl){
      if(variant.compare_at_price && variant.compare_at_price > variant.price){
        compareEl.style.display = '';
        compareEl.textContent = formatMoney(variant.compare_at_price);
      }else{
        compareEl.style.display = 'none';
      }
    }
    if(atcBtn){
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }

    // 更新图片：根据变体关联的图片进行切换
    if(heroImg && product.images && product.images.length > 0){
      let targetImage = null;
      
      // 方法1: 使用变体的 image_id（Shopify 标准方式）
      if(variant.image_id){
        targetImage = product.images.find(img => {
          return String(img.id) === String(variant.image_id);
        });
      }
      
      // 方法2: 检查图片的 variant_ids 数组（图片关联的变体列表）
      if(!targetImage){
        targetImage = product.images.find(img => {
          if(img.variant_ids && Array.isArray(img.variant_ids)){
            return img.variant_ids.some(vid => String(vid) === String(variant.id));
          }
          return false;
        });
      }
      
      // 方法3: 根据颜色值匹配（如果前两种方法都失败）
      if(!targetImage){
        const colorValue = selected[0]; // 第一个选项通常是颜色
        if(colorValue){
          const colorLower = colorValue.toLowerCase();
          // 匹配中文颜色：黑、粉、红、蓝、绿等
          const colorMap = {
            '黑': ['black', '黑', 'black-'],
            '粉': ['pink', '粉', 'pink-'],
            '红': ['red', '红', 'red-'],
            '蓝': ['blue', '蓝', 'blue-'],
            '绿': ['green', '绿', 'green-'],
            '橙': ['orange', '橙', 'orange-'],
            '白': ['white', '白', 'white-']
          };
          
          const searchTerms = colorMap[colorValue] || [colorLower];
          
          targetImage = product.images.find(img => {
            const alt = (img.alt || '').toLowerCase();
            const src = (img.src || '').toLowerCase();
            return searchTerms.some(term => alt.includes(term) || src.includes(term));
          });
        }
      }
      
      // 如果找到匹配图片，切换到该图片
      if(targetImage){
        let newSrc = targetImage.src || targetImage.url || targetImage;
        
        if(newSrc && typeof newSrc === 'string'){
          // 移除 srcset，强制重新加载
          heroImg.removeAttribute('srcset');
          
          // 确保使用 1600px 宽度的图片
          if(newSrc.includes('cdn.shopify.com')){
            // 如果 URL 中没有尺寸参数，添加 _1600x
            if(!newSrc.match(/_\d+x\./)){
              newSrc = newSrc.replace(/(\.(jpg|jpeg|png|webp))(\?|$)/i, '_1600x$1$3');
            }
          }
          
          // 更新主图
          heroImg.src = newSrc;
          
          // 更新缩略图：根据变体过滤显示，只显示该变体关联的图片
          if(thumbButtons && thumbButtons.length > 0){
            const variantIdStr = String(variant.id);
            
            thumbButtons.forEach(btn => {
              const btnVariantIds = btn.getAttribute('data-variant-ids');
              const btnImageId = btn.getAttribute('data-image-id');
              const targetImgId = String(targetImage.id);
              
              // 判断该缩略图是否属于当前变体
              let isVariantImage = false;
              
              // 方法1: 检查图片的 variant_ids 是否包含当前变体
              if(btnVariantIds){
                const variantIds = btnVariantIds.split(',').map(id => String(id.trim()));
                isVariantImage = variantIds.includes(variantIdStr);
              }
              
              // 方法2: 如果图片 ID 匹配，也显示
              if(!isVariantImage && btnImageId === targetImgId){
                isVariantImage = true;
              }
              
              // 方法3: 如果没有 variant_ids，显示所有图片（向后兼容）
              if(!btnVariantIds){
                isVariantImage = true;
              }
              
              // 显示/隐藏缩略图
              if(isVariantImage){
                btn.style.display = '';
                // 如果是主图，添加高亮
                if(btnImageId === targetImgId){
                  btn.classList.add('is-active');
                }else{
                  btn.classList.remove('is-active');
                }
              }else{
                btn.style.display = 'none';
                btn.classList.remove('is-active');
              }
            });
          }
        }
      }
    }
  }

  function formatMoney(cents){
    // simple fallback; uses Shopify money format if present
    const fmt = themeFlag('moneyFormat') || "${{amount}}";
    const amount = (cents/100).toFixed(2);
    return fmt.replace("{{amount}}", amount).replace("{{amount_no_decimals}}", Math.round(cents/100));
  }

  // chips click
  document.addEventListener('click', (e)=>{
    const chip = e.target.closest('[data-chip]');
    if(!chip || !form.contains(chip)) return;
    const row = chip.closest('[data-option-index]');
    if(!row) return;
    const idx = Number(row.getAttribute('data-option-index'));
    const val = chip.getAttribute('data-value');
    selected[idx] = val;

    row.querySelectorAll('[data-chip]').forEach(c=>c.classList.toggle('is-active', c === chip));

    const variant = findVariant();
    updateUI(variant);
  });

  // set active chips on load
  optionRows.forEach(row=>{
    const idx = Number(row.getAttribute('data-option-index'));
    const val = selected[idx];
    const chip = Array.from(row.querySelectorAll('[data-chip]')).find(c=>c.getAttribute('data-value')===val);
    if(chip) chip.classList.add('is-active');
  });
  updateUI(findVariant() || defaultVariant);

  // quantity controls
  const qty = form.querySelector('[data-qty]');
  form.addEventListener('click', (e)=>{
    const inc = e.target.closest('[data-qty-inc]');
    const dec = e.target.closest('[data-qty-dec]');
    if(!qty) return;
    if(inc){ qty.value = String(Math.max(1, Number(qty.value||1)+1)); }
    if(dec){ qty.value = String(Math.max(1, Number(qty.value||1)-1)); }
  });

  // sticky ATC show/hide when main ATC not visible
  if(sticky && stickyBtn && atcBtn){
    const obs = new IntersectionObserver((entries)=>{
      entries.forEach(en=>{
        const show = !en.isIntersecting;
        sticky.hidden = !show;
      });
    }, {threshold: 0.2});
    obs.observe(atcBtn);

    stickyBtn.addEventListener('click', ()=>{
      atcBtn.scrollIntoView({behavior:'smooth', block:'center'});
      setTimeout(()=>atcBtn.click(), 250);
    });
  }
})();

// Cart drawer live render (basic)
function moneyFromFormat(fmt, cents){
  const amount = (cents/100).toFixed(2);
  return (fmt || "${{amount}}").replace("{{amount}}", amount).replace("{{amount_no_decimals}}", Math.round(cents/100));
}

async function refreshDrawer(){
  const drawer = document.querySelector('[data-cart-drawer]');
  if(!drawer) return;
  const body = drawer.querySelector('[data-cart-body]');
  const sub = drawer.querySelector('[data-cart-subtotal]');
  const badge = document.querySelector('[data-cart-count]');
  try{
    const res = await fetch('/cart.js');
    if(!res.ok) return;
    const cart = await res.json();
    if(badge) badge.textContent = cart.item_count;
    if(sub) sub.textContent = moneyFromFormat(themeFlag('moneyFormat'), cart.total_price);

    if(!body) return;
    if(cart.item_count === 0){
      body.innerHTML = '<p class="empty">Your cart is empty.</p>';
      return;
    }
    const items = cart.items.map(it=>{
      const img = it.image ? `<img src="${it.image}" alt="">` : '';
      const url = it.url || '/cart';
      const price = moneyFromFormat(themeFlag('moneyFormat'), it.final_line_price);
      const variant = it.variant_title ? `<p class="ci-variant">${it.variant_title}</p>` : '';
      return `
        <li class="cart-item">
          <a class="ci-img" href="${url}">${img}</a>
          <div class="ci-info">
            <a class="ci-title" href="${url}">${it.product_title}</a>
            ${variant}
            <p class="ci-price">${price}</p>
          </div>
        </li>
      `;
    }).join('');
    body.innerHTML = `<ul class="cart-list">${items}</ul>`;
  }catch(e){}
}

// Hook refresh to quick add success & form submit
document.addEventListener('submit', async (e)=>{
  const form = e.target.closest('form[action^="/cart/add"]') || (e.target.id === 'product-form' ? e.target : null);
  if(!form) return;
  // allow normal submit if drawer disabled
  if(!themeFlag('cartDrawer')) return;
  e.preventDefault();
  const fd = new FormData(form);
  try{
    const res = await fetch('/cart/add.js', {method:'POST', body: fd});
    if(!res.ok) throw new Error('ATC failed');
    await refreshDrawer();
    const drawer = document.querySelector('[data-cart-drawer]');
    if(drawer){ drawer.hidden = false;
    requestAnimationFrame(()=>drawer.classList.add('is-open')); document.documentElement.style.overflow='hidden'; }
  }catch(err){
    window.location.href='/cart';
  }
});



function shake(el){
  if(!themeFlag('shakeOnError') || !el) return;
  el.classList.remove('shake');
  // force reflow
  void el.offsetWidth;
  el.classList.add('shake');
  setTimeout(()=>el.classList.remove('shake'), 420);
}

// Cursor glow
(function(){
  if(!themeFlag('cursorGlow')) return;
  const glow = document.querySelector('[data-cursor-glow]');
  if(!glow) return;
  let x = -9999, y = -9999, tx = x, ty = y;
  const speed = 0.18;
  const move = (e)=>{
    tx = e.clientX; ty = e.clientY;
  };
  window.addEventListener('mousemove', move, {passive:true});
  const tick = ()=>{
    x += (tx - x) * speed;
    y += (ty - y) * speed;
    glow.style.transform = `translate(${x - glow.offsetWidth/2}px, ${y - glow.offsetHeight/2}px)`;
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
})();

// Magnetic buttons
(function(){
  if(!themeFlag('magnetBtns')) return;
  const strength = Number(themeFlag('magnet') != null ? themeFlag('magnet') : 12);
  const sel = '.btn, .icon-btn, .chip, .qty-btn';
  const els = document.querySelectorAll(sel);
  if(!els.length) return;

  function onMove(e){
    const el = e.currentTarget;
    const r = el.getBoundingClientRect();
    const mx = e.clientX - (r.left + r.width/2);
    const my = e.clientY - (r.top + r.height/2);
    const dx = Math.max(-strength, Math.min(strength, mx/6));
    const dy = Math.max(-strength, Math.min(strength, my/6));
    el.style.transform = `translate(${dx}px, ${dy}px)`;
  }
  function onLeave(e){
    const el = e.currentTarget;
    el.style.transform = '';
  }

  // Only desktop
  if(window.matchMedia('(hover:hover) and (pointer:fine)').matches){
    els.forEach(el=>{
      el.addEventListener('mousemove', onMove);
      el.addEventListener('mouseleave', onLeave);
    });
  }
})();


// Fly-to-cart animation (best effort)
function flyToCart(fromEl){
  if(!themeFlag('flyToCart')) return;
  const cartBtn = document.querySelector('[data-cart-toggle]');
  if(!fromEl || !cartBtn) return;

  // find image inside a product card or pdp
  let card = fromEl.closest('.product-card');
  let img = (card ? card.querySelector('img') : null) ||
            document.querySelector('.pdp-hero-img') ||
            fromEl.querySelector('img');

  if(!img) return;

  const r1 = img.getBoundingClientRect();
  const r2 = cartBtn.getBoundingClientRect();

  const clone = img.cloneNode(true);
  const wrap = document.createElement('div');
  wrap.className = 'fly';
  wrap.style.left = r1.left + 'px';
  wrap.style.top = r1.top + 'px';
  wrap.style.width = r1.width + 'px';
  wrap.style.height = r1.height + 'px';
  wrap.style.transition = 'transform .65s var(--ease), opacity .65s var(--ease), width .65s var(--ease), height .65s var(--ease)';
  clone.style.width = '100%';
  clone.style.height = '100%';
  clone.style.objectFit = 'cover';
  wrap.appendChild(clone);
  document.body.appendChild(wrap);

  const tx = (r2.left + r2.width/2) - (r1.left + r1.width/2);
  const ty = (r2.top + r2.height/2) - (r1.top + r1.height/2);

  requestAnimationFrame(()=>{
    wrap.style.transform = `translate3d(${tx}px, ${ty}px, 0) scale(.18)`;
    wrap.style.opacity = '0.15';
  });

  setTimeout(()=>{ wrap.remove(); }, 720);
}



// Lightbox (PDP images)
(function(){
  if(!themeFlag('lightbox')) return;
  const lb = document.querySelector('[data-lightbox]');
  if(!lb) return;
  const imgEl = lb.querySelector('[data-lb-img]');
  const closeBtns = lb.querySelectorAll('[data-lb-close]');
  const prevBtn = lb.querySelector('[data-lb-prev]');
  const nextBtn = lb.querySelector('[data-lb-next]');

  let list = [];
  let idx = 0;

  function openAt(i){
    idx = (i + list.length) % list.length;
    if(imgEl) imgEl.src = list[idx];
    lb.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }
  function close(){
    lb.hidden = true;
    document.documentElement.style.overflow = '';
  }
  function prev(){ openAt(idx - 1); }
  function next(){ openAt(idx + 1); }

  closeBtns.forEach(b=>b.addEventListener('click', close));
  if(prevBtn) prevBtn.addEventListener('click', prev);
  if(nextBtn) nextBtn.addEventListener('click', next);
  document.addEventListener('keydown', (e)=>{
    if(lb.hidden) return;
    if(e.key === 'Escape') close();
    if(e.key === 'ArrowLeft') prev();
    if(e.key === 'ArrowRight') next();
  });

  document.addEventListener('click', (e)=>{
    // Build list from pdp thumbs if present
    const thumbs = Array.from(document.querySelectorAll('[data-pdp-thumb]'));
    if(thumbs.length){
      list = thumbs.map(t=>t.getAttribute('data-src')).filter(Boolean);
    }else{
      list = [];
    }

    const hero = e.target.closest('.pdp-hero-img');
    if(hero && list.length){
      const current = hero.getAttribute('src');
      const i = Math.max(0, list.indexOf(current));
      openAt(i);
      return;
    }

    const t = e.target.closest('[data-pdp-thumb]');
    if(t && list.length){
      const src = t.getAttribute('data-src');
      const i = Math.max(0, list.indexOf(src));
      openAt(i);
    }
  });
})();


  // Header hide on scroll down
  (function(){
    if(!document.body.classList.contains('hos-on')) return;
    const hdr = document.querySelector('[data-section="header"]');
    if(!hdr) return;
    let lastY = window.scrollY;
    let ticking = false;
    const threshold = 12;

    const onScroll = ()=>{
      const y = window.scrollY;
      const diff = y - lastY;
      if(Math.abs(diff) > threshold){
        if(diff > 0 && y > 120){
          hdr.classList.add('is-hidden');
        }else{
          hdr.classList.remove('is-hidden');
        }
        lastY = y;
      }
      ticking = false;
    };

    window.addEventListener('scroll', ()=>{
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(onScroll);
    }, {passive:true});
  })();


// Predictive search (Shopify suggest)
(function(){
  const modal = document.querySelector('[data-search]');
  const openBtn = document.querySelector('[data-search-toggle]');
  const closes = document.querySelectorAll('[data-search-close]');
  const input = document.querySelector('[data-search-input]');
  const out = document.querySelector('[data-search-results]');
  if(!modal || !openBtn || !input || !out) return;

  const open = ()=>{
    modal.hidden = false;
    document.documentElement.style.overflow='hidden';
    setTimeout(()=>input.focus(), 0);
  };
  const close = ()=>{
    modal.hidden = true;
    document.documentElement.style.overflow='';
  };
  openBtn.addEventListener('click', open);
  closes.forEach(b=>b.addEventListener('click', close));
  document.addEventListener('keydown', (e)=>{ if(e.key==='Escape' && !modal.hidden) close(); });

  let t = null;
  async function query(q){
    const multi = !!themeFlag('searchMulti');
      const includeArticles = !!themeFlag('searchArticles');
      const types = includeArticles ? 'product,collection,page,article' : 'product,collection,page';
      const url = multi
        ? `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=${types}&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`
        : `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title`;
    const res = await fetch(url, {headers:{'Accept':'application/json'}});
    if(!res.ok) return null;
    return await res.json();
  }

  
let activeTab = 'products';

// Tabs
const tabs = modal.querySelectorAll('[data-tab]');
if(tabs.length){
  tabs.forEach(t=>{
    t.addEventListener('click', ()=>{
      tabs.forEach(x=>{
        x.classList.toggle('is-active', x===t);
        x.setAttribute('aria-selected', x===t ? 'true' : 'false');
      });
      activeTab = t.getAttribute('data-tab') || 'products';
      // re-render from lastData if available
      if(window.__lastSuggestData) render(window.__lastSuggestData);
    });
  });
}

function renderProducts(items){
  return items.map(p=>{
    const img = p.image ? `<img src="${p.image}" alt="">` : `<div style="width:56px;height:56px;border-radius:14px;background:rgba(0,0,0,.04)"></div>`;
    const price = (p.price != null) ? ((themeFlag('moneyFormat') || '${{amount}}').replace('{{amount}}', (p.price/100).toFixed(2))) : '';
    return `
      <a class="sr-item" href="${p.url}">
        ${img}
        <div>
          <div class="sr-title">${p.title}</div>
          <div style="color:rgba(0,0,0,.62);font-size:13px">${p.product_type || ''}</div>
        </div>
        <div class="sr-price">${price}</div>
      </a>
    `;
  }).join('');
}

function renderCollections(items){
  return items.map(c=>{
    const img = c.image ? `<img src="${c.image}" alt="">` : `<div style="width:56px;height:56px;border-radius:14px;background:rgba(0,0,0,.04)"></div>`;
    return `
      <a class="sr-item" href="${c.url}">
        ${img}
        <div>
          <div class="sr-title">${c.title}</div>
          <div style="color:rgba(0,0,0,.62);font-size:13px">Collection</div>
        </div>
        <div class="sr-price">→</div>
      </a>
    `;
  }).join('');
}

function renderPages(items){
  return items.map(p=>{
    return `
      <a class="sr-item" href="${p.url}">
        <div style="width:56px;height:56px;border-radius:14px;background:rgba(0,0,0,.04);display:grid;place-items:center;font-weight:900">P</div>
        <div>
          <div class="sr-title">${p.title}</div>
          <div style="color:rgba(0,0,0,.62);font-size:13px">Page</div>
        </div>
        <div class="sr-price">→</div>
      </a>
    `;
  }).join('');
}

function render(data){
  window.__lastSuggestData = data;
  var res = (data && data.resources && data.resources.results) ? data.resources.results : {};
  const products = res.products || [];
  const collections = res.collections || [];
  const pages = res.pages || [];
  const articles = res.articles || [];
      const map = {products, collections, pages, articles};
  const items = map[activeTab] || products;

  if(!items.length){
    out.innerHTML = `<div class="search-hint">No results. Try another keyword.</div>`;
    return;
  }

  if(activeTab === 'collections') out.innerHTML = renderCollections(items);
  else if(activeTab === 'pages') out.innerHTML = renderPages(items);
  else out.innerHTML = renderProducts(items);
}

  input.addEventListener('input', ()=>{
    const q = input.value.trim();
    if(t) clearTimeout(t);
    if(q.length < 2){ out.innerHTML = ''; return; }
    t = setTimeout(async ()=>{
      try{
        const data = await query(q);
        if(data) render(data);
      }catch(e){}
    }, 140);
  });
})();

// Mobile nav drawer
(function(){
  const drawer = document.querySelector('[data-nav-drawer]');
  const openBtn = document.querySelector('[data-nav-toggle]');
  const closes = document.querySelectorAll('[data-nav-close]');
  if(!drawer || !openBtn) return;

  const open = ()=>{
    drawer.hidden = false;
    document.documentElement.style.overflow='hidden';
    requestAnimationFrame(()=>drawer.classList.add('is-open'));
  };
  const close = ()=>{
    drawer.classList.remove('is-open');
    setTimeout(()=>{ drawer.hidden = true; document.documentElement.style.overflow=''; }, 220);
  };
  openBtn.addEventListener('click', open);
  closes.forEach(b=>b.addEventListener('click', close));
  document.addEventListener('keydown', (e)=>{ if(e.key==='Escape' && !drawer.hidden) close(); });
})();

// Promo countdown
(function(){
  const el = document.querySelector('[data-promo-timer]');
  const out = document.querySelector('[data-pt-time]');
  if(!el || !out) return;
  const endStr = el.getAttribute('data-end');
  if(!endStr) return;
  const end = new Date(endStr).getTime();
  if(Number.isNaN(end)) return;

  function tick(){
    const now = Date.now();
    let s = Math.max(0, Math.floor((end - now)/1000));
    const h = String(Math.floor(s/3600)).padStart(2,'0'); s %= 3600;
    const m = String(Math.floor(s/60)).padStart(2,'0'); s %= 60;
    const ss = String(s).padStart(2,'0');
    out.textContent = `${h}:${m}:${ss}`;
    if(end - now <= 0){ el.style.display='none'; return; }
    requestAnimationFrame(()=>{});
    setTimeout(tick, 1000);
  }
  tick();
})();

// Swipe-to-close (mobile drawers)
(function(){
  if(!themeFlag('swipeClose')) return;
  if(!window.matchMedia('(max-width: 980px)').matches) return;

  function attach(panelSel, closeFn){
    const panel = document.querySelector(panelSel);
    if(!panel) return;
    let sx=0, sy=0, active=false;

    panel.addEventListener('touchstart', (e)=>{
      const t = e.touches[0];
      sx = t.clientX; sy = t.clientY; active=true;
    }, {passive:true});

    panel.addEventListener('touchmove', (e)=>{
      if(!active) return;
      const t = e.touches[0];
      const dx = t.clientX - sx;
      const dy = t.clientY - sy;
      if(Math.abs(dx) > 60 && Math.abs(dy) < 50){
        active=false;
        closeFn();
      }
    }, {passive:true});
  }

  // nav drawer
  (function(){
    const drawer = document.querySelector('[data-nav-drawer]');
    if(!drawer) return;
    const close = ()=>{ drawer.classList.remove('is-open'); setTimeout(()=>{ drawer.hidden=true; document.documentElement.style.overflow=''; }, 220); };
    attach('.navd-panel', close);
  })();

  // cart drawer
  (function(){
    const drawer = document.querySelector('[data-cart-drawer]');
    if(!drawer) return;
    const close = ()=>{ drawer.classList.remove('is-open'); setTimeout(()=>{ drawer.hidden=true; document.documentElement.style.overflow=''; }, 220); };
    attach('.drawer-panel', close);
  })();
})();

// Drawer drag-follow (mobile) with resistance
(function(){
  if(!themeFlag('drawerDrag')) return;
  if(!window.matchMedia('(max-width: 980px)').matches) return;
  const threshold = Number(themeFlag('dragThreshold') != null ? themeFlag('dragThreshold') : 110);

  function clamp(v, a, b){ return Math.max(a, Math.min(b, v)); }

  function attach(panelSel, drawerSel, closeFn, direction){
    const drawer = document.querySelector(drawerSel);
    const panel = document.querySelector(panelSel);
    if(!drawer || !panel) return;

    let sx=0, sy=0, active=false, dx=0;

    const onStart = (e)=>{
      const t = e.touches[0];
      sx = t.clientX; sy = t.clientY; dx = 0; active = true;
      panel.style.transition = 'none';
    };
    const onMove = (e)=>{
      if(!active) return;
      const t = e.touches[0];
      const mx = t.clientX - sx;
      const my = t.clientY - sy;
      if(Math.abs(my) > 70 && Math.abs(mx) < 30) return; // allow vertical scrolling
      // only allow swipe left-to-close for cart drawer (from right), and right-to-close for nav (from left)
      dx = mx;
      const signed = direction === 'left' ? clamp(mx, -280, 0) : clamp(mx, 0, 280);
      // resistance
      const r = signed * 0.85;
      panel.style.transform = `translateX(${r}px)`;
    };
    const onEnd = ()=>{
      if(!active) return;
      active = false;
      panel.style.transition = '';
      const shouldClose = direction === 'left' ? (dx < -threshold) : (dx > threshold);
      if(shouldClose){
        closeFn();
      }else{
        panel.style.transform = '';
      }
    };

    panel.addEventListener('touchstart', onStart, {passive:true});
    panel.addEventListener('touchmove', onMove, {passive:true});
    panel.addEventListener('touchend', onEnd, {passive:true});
    panel.addEventListener('touchcancel', onEnd, {passive:true});
  }

  // nav drawer closes by swiping right
  (function(){
    const drawer = document.querySelector('[data-nav-drawer]');
    if(!drawer) return;
    const close = ()=>{ drawer.classList.remove('is-open'); setTimeout(()=>{ drawer.hidden=true; document.documentElement.style.overflow=''; }, 220); };
    attach('.navd-panel', '[data-nav-drawer]', close, 'right');
  })();

  // cart drawer closes by swiping left
  (function(){
    const drawer = document.querySelector('[data-cart-drawer]');
    if(!drawer) return;
    const close = ()=>{ drawer.classList.remove('is-open'); setTimeout(()=>{ drawer.hidden=true; document.documentElement.style.overflow=''; }, 220); };
    attach('.drawer-panel', '[data-cart-drawer]', close, 'left');
  })();
})();

// Recently viewed storage (PDP)
(function(){
  if(!themeFlag('recentlyViewed')) return;
      const rvQuickAdd = !!themeFlag('rvQuickAdd');
  const jsonEl = document.querySelector('[id^="ProductJson-"]');
  if(!jsonEl) return;
  let product;
  try{ product = JSON.parse(jsonEl.textContent); }catch(e){ return; }
  if(!product || !product.id) return;

  const key = 'rv_products_v1';
  const item = {
    id: product.id,
    title: product.title,
    url: window.location.pathname,
    image: product.featured_image ? product.featured_image : null,
    price: (product.variants && product.variants[0]) ? product.variants[0].price : null,
    ts: Date.now()
  };

  let list = [];
  try{ list = JSON.parse(localStorage.getItem(key) || '[]'); }catch(_){ list = []; }
  // de-dup
  list = list.filter(x=>x && x.id !== item.id);
  list.unshift(item);
  const limit = Number(themeFlag('rvLimit') != null ? themeFlag('rvLimit') : 6);
  list = list.slice(0, Math.max(1, limit));
  try{ localStorage.setItem(key, JSON.stringify(list)); }catch(_){}
})();

// Render recently viewed inside search modal
(function(){
  const modal = document.querySelector('[data-search]');
  if(!modal) return;
  const rv = modal.querySelector('[data-rv]');
  const grid = modal.querySelector('[data-rv-grid]');
  const clear = modal.querySelector('[data-rv-clear]');
  if(!rv || !grid || !clear) return;

  const key = 'rv_products_v1';

  function money(cents){
    if(cents == null) return '';
    const fmt = themeFlag('moneyFormat') || "${{amount}}";
    return fmt.replace("{{amount}}", (cents/100).toFixed(2));
  }

  function render(){
    if(!themeFlag('recentlyViewed')) return;
      const rvQuickAdd = !!themeFlag('rvQuickAdd');
    let list = [];
    try{ list = JSON.parse(localStorage.getItem(key) || '[]'); }catch(_){ list = []; }
    if(!list.length){ rv.hidden = true; return; }
    rv.hidden = false;

    grid.innerHTML = list.map(p=>{
      const img = p.image ? `<img src="${p.image}" alt="">` : `<div style="width:56px;height:56px;border-radius:14px;background:rgba(0,0,0,.04)"></div>`;
      const price = p.price != null ? money(p.price) : '';
      return `
        <a class="rv-card" href="${p.url}">
          ${img}
          <div>
            <div class="rv-name">${p.title}</div>
            <div class="rv-meta">${price}</div>
          </div>
        </a>
      `;
    }).join('');
  }

  // Hook into search open (we detect it when modal becomes visible)
  const obs = new MutationObserver(()=>{ if(!modal.hidden) render(); });
  obs.observe(modal, {attributes:true, attributeFilter:['hidden']});

  clear.addEventListener('click', ()=>{
    try{ localStorage.removeItem(key); }catch(_){}
    render();
  });
})();

// Keyboard navigation in search results
(function(){
  if(!themeFlag('searchKeys')) return;
  const modal = document.querySelector('[data-search]');
  const input = document.querySelector('[data-search-input]');
  const out = document.querySelector('[data-search-results]');
  if(!modal || !input || !out) return;

  let idx = -1;

  function items(){ return Array.from(out.querySelectorAll('.sr-item')); }
  function setActive(i){
    const list = items();
    list.forEach((el, k)=>el.classList.toggle('is-active', k===i));
    idx = i;
  }

  input.addEventListener('keydown', (e)=>{
    if(modal.hidden) return;
    const list = items();
    if(!list.length) return;

    if(e.key === 'ArrowDown'){
      e.preventDefault();
      setActive((idx + 1) % list.length);
      list[(idx+1) % list.length].scrollIntoView({block:'nearest'});
    }
    if(e.key === 'ArrowUp'){
      e.preventDefault();
      setActive((idx - 1 + list.length) % list.length);
      list[(idx - 1 + list.length) % list.length].scrollIntoView({block:'nearest'});
    }
    if(e.key === 'Enter' && idx >= 0){
      const el = list[idx];
      if(el && el.getAttribute('href')){
        window.location.href = el.getAttribute('href');
      }
    }
  });

  // reset when results change
  const obs = new MutationObserver(()=>{ idx = -1; });
  obs.observe(out, {childList:true, subtree:true});
})();

// Recent searches (search modal)
(function(){
  if(!themeFlag('recentSearches')) return;
  const modal = document.querySelector('[data-search]');
  const input = document.querySelector('[data-search-input]');
  const rs = modal ? modal.querySelector('[data-rs]') : null;
  const chips = modal ? modal.querySelector('[data-rs-chips]') : null;
  const clear = modal ? modal.querySelector('[data-rs-clear]') : null;
  if(!modal || !input || !rs || !chips || !clear) return;

  const key = 'recent_searches_v1';

  function getList(){
    let list = [];
    try{ list = JSON.parse(localStorage.getItem(key) || '[]'); }catch(_){ list = []; }
    return Array.isArray(list) ? list : [];
  }
  function setList(list){
    try{ localStorage.setItem(key, JSON.stringify(list)); }catch(_){}
  }
  function render(){
    const list = getList();
    if(!list.length){ rs.hidden = true; return; }
    rs.hidden = false;
    chips.innerHTML = list.map(q=>`<button class="chip rs-chip" type="button" data-rs-q="${q}">${q}</button>`).join('');
  }

  // When modal opens
  const obs = new MutationObserver(()=>{ if(!modal.hidden) render(); });
  obs.observe(modal, {attributes:true, attributeFilter:['hidden']});

  // Store when user pauses typing (and >=2 chars)
  let t = null;
  input.addEventListener('input', ()=>{
    if(t) clearTimeout(t);
    const q = input.value.trim();
    if(q.length < 2) return;
    t = setTimeout(()=>{
      let list = getList().filter(x=>x !== q);
      list.unshift(q);
      const limit = Number(themeFlag('rsLimit') != null ? themeFlag('rsLimit') : 8);
      list = list.slice(0, Math.max(1, limit));
      setList(list);
      render();
    }, 650);
  });

  // click chip
  chips.addEventListener('click', (e)=>{
    const b = e.target.closest('[data-rs-q]');
    if(!b) return;
    const q = b.getAttribute('data-rs-q') || '';
    input.value = q;
    input.dispatchEvent(new Event('input', {bubbles:true}));
    input.focus();
  });

  clear.addEventListener('click', ()=>{
    try{ localStorage.removeItem(key); }catch(_){}
    render();
  });
})();

// Tab to switch search category (when search modal open)
(function(){
  if(!themeFlag('searchTabKeys')) return;
  const modal = document.querySelector('[data-search]');
  const input = document.querySelector('[data-search-input]');
  if(!modal || !input) return;
  const tabs = Array.from(modal.querySelectorAll('[data-tab]'));
  if(!tabs.length) return;

  function activeIndex(){
    return Math.max(0, tabs.findIndex(t=>t.classList.contains('is-active')));
  }
  function activate(i){
    const t = tabs[(i + tabs.length) % tabs.length];
    t.click();
  }

  input.addEventListener('keydown', (e)=>{
    if(modal.hidden) return;
    if(e.key !== 'Tab') return;
    e.preventDefault();
    const i = activeIndex();
    activate(e.shiftKey ? i-1 : i+1);
  });
})();